import '../ActivityActions.scss';
import React from 'react';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { IRollbackPerformerProps } from './IRollbackPerformerProps';

export const RollbackPerformerModal: React.FC<IRollbackPerformerProps> = (props: IRollbackPerformerProps) => {
    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new ActivityExecutionService().saveRollbackPerformer(props.actionKey, props.activityId),
    });

    const messageBoxProp: IMessageDialogProps = {
        header: `${props.title}`,
        message: ``,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} loading={isBusy} />;
};
